import { default as Account } from './ContentAccount/ContentAccount.container';
import { default as Api } from './ContentApi/ContentApi.container';
import { default as AssetPacks } from './ContentAssetPacks/ContentAssetPacks.container';
import { default as Backdrops } from './ContentBackdrops/ContentBackdrops.container';
import { default as Browse } from './ContentBrowse/ContentBrowse.container';
import { default as Celebration } from './ContentCelebration/ContentCelebration.container';
import { default as Discord } from './ContentDiscord/ContentDiscord.container';
import { default as Docs } from './ContentDocs/ContentDocs.container';
import { default as Events } from './ContentEvents/ContentEvents.container';
import { default as Generators } from './ContentGenerators/ContentGenerators.container';
import { default as HireCreator } from './ContentHireCreator/ContentHireCreator.container';
import { default as MadeWithSloyd } from './ContentMadeWithSloyd/ContentMadeWithSloyd.container';
import { default as Materials } from './ContentMaterials/ContentMaterials.container';
import { default as Offer } from './ContentOffer/ContentOffer.container';
import { default as Plugins } from './ContentPlugins/ContentPlugins.container';
import { default as Pricing } from './ContentPricing/ContentPricing.container';
import { default as Projects } from './ContentProjects/ContentProjects.container';
import { default as Settings } from './ContentSettings/ContentSettings.container';
import { default as Textures } from './ContentTextures/ContentTextures.container';
import { default as Tools } from './ContentTools/ContentTools.container';
import { default as Tutorials } from './ContentTutorials/ContentTutorials.container';
import { default as Usage } from './ContentUsage/ContentUsage.container';
import { default as UseCases } from './ContentUseCases/ContentUseCases.container';
import { default as WhatsNew } from './ContentWhatsNew/ContentWhatsNew.container';

export const content = {
  Account,
  Api,
  AssetPacks,
  Browse,
  Materials,
  Offer,
  Backdrops,
  Discord,
  Pricing,
  Docs,
  Events,
  Generators,
  Celebration,
  HireCreator,
  MadeWithSloyd,
  Plugins,
  Projects,
  Settings,
  Textures,
  Tools,
  Tutorials,
  Usage,
  UseCases,
  WhatsNew,
};
